export default __webpack_public_path__ + "static/media/Balance Bike Day flyer.85568122.pdf";